import "core-js/modules/es.function.name.js";
import { IPayoutTermEnum } from "@faire/web-api/indigofair/data/IPayoutTermEnum";
import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";
export var getBrand = function getBrand() {
  return getGlobalProperty("brand");
};
export var getBrandToken = function getBrandToken() {
  var _getBrand;
  return (_getBrand = getBrand()) === null || _getBrand === void 0 ? void 0 : _getBrand.token;
};
export var getBrandBusinessName = function getBrandBusinessName() {
  var _getBrand2;
  return (_getBrand2 = getBrand()) === null || _getBrand2 === void 0 ? void 0 : _getBrand2.name;
};
export var getBrandEmail = function getBrandEmail() {
  var _getBrand3;
  return (_getBrand3 = getBrand()) === null || _getBrand3 === void 0 ? void 0 : _getBrand3.email_address;
};
export var getBrandPayoutTerm = function getBrandPayoutTerm() {
  var _getBrand4;
  return (_getBrand4 = getBrand()) === null || _getBrand4 === void 0 ? void 0 : _getBrand4.payout_term;
};
export var hasPayoutTerm = function hasPayoutTerm() {
  return !!getBrandPayoutTerm() && getBrandPayoutTerm() !== IPayoutTermEnum.PayoutTerm.UNSPECIFIED;
};
export var getBrandBasedIn = function getBrandBasedIn() {
  var _getBrand5;
  return (_getBrand5 = getBrand()) === null || _getBrand5 === void 0 ? void 0 : _getBrand5.based_in;
};
export var isLoggedInBrand = function isLoggedInBrand() {
  return !!getBrandToken();
};